var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorderApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Myorder_Approved"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Myorder_Approved",
    clipPath: "url(#clip-Myorder_Approved)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860",
    transform: "translate(-537.842 -487.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753",
    transform: "translate(538.144 488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-button",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19440",
    "data-name": "Path 19440",
    d: "M94.48,101.964a6.682,6.682,0,1,1,6.684-6.672A6.688,6.688,0,0,1,94.48,101.964Zm-5.716-6.7a5.726,5.726,0,1,0,5.776-5.712A5.741,5.741,0,0,0,88.764,95.264Z",
    transform: "translate(-87.8 -88.6)",
    fill: "#80b400",
    stroke: "#80b400",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19442",
    "data-name": "Path 19442",
    d: "M5.588,8.776l1.449,1.709,2.982-2.837",
    transform: "translate(-1.332 -2.385)",
    fill: "none",
    stroke: "#80b400",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorderApproved);
export default __webpack_public_path__ + "static/media/Myorder_Approved.4fee94b4bbf49f5d6cb77054d872d351.svg";
export { ForwardRef as ReactComponent };